var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhancesSeamlessCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 67,
    width: 64.5,
    x: 17.7,
    y: -83.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,54.6c-3.8,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S18.7,54.6,14.9,54.6z M14.9,43.2c-2.4,0-4.4,2-4.4,4.4 s2,4.4,4.4,4.4s4.4-2,4.4-4.4S17.3,43.2,14.9,43.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,69.1H3.7v-6c0-6.1,5-11.1,11.1-11.1S26,56.9,26,63.1V69.1z M6.3,66.5h17.2v-3.5c0-4.7-3.9-8.6-8.6-8.6 s-8.6,3.9-8.6,8.6V66.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,55.1c-3.8,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S61,55.1,57.1,55.1z M57.1,43.7c-2.4,0-4.4,2-4.4,4.4 c0,2.4,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4C61.6,45.7,59.6,43.7,57.1,43.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,69.5H46v-6c0-6.1,5-11.1,11.1-11.1s11.1,5,11.1,11.1V69.5z M48.5,67h17.2v-3.5c0-4.7-3.9-8.6-8.6-8.6 s-8.6,3.9-8.6,8.6V67z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,16.4c-3.8,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S39.8,16.4,36,16.4z M36,5c-2.4,0-4.4,2-4.4,4.4 s2,4.4,4.4,4.4s4.4-2,4.4-4.4S38.4,5,36,5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,30.9H24.8v-6c0-6.1,5-11.1,11.1-11.1s11.1,5,11.1,11.1V30.9z M27.4,28.3h17.2v-3.5 c0-4.7-3.9-8.6-8.6-8.6s-8.6,3.9-8.6,8.6V28.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,37.4c-0.1,0-0.1,0-0.2,0c-0.8-0.1-1.4-0.9-1.3-1.7c1-7.2,4.9-13.9,10.9-18.4c0.7-0.5,1.6-0.4,2.1,0.3 c0.5,0.7,0.4,1.6-0.3,2.1c-5.4,4-8.9,9.8-9.7,16.4C12.7,36.9,12,37.4,11.3,37.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,56.7c-3.5,0-7.1-0.7-10.4-2c-0.8-0.3-1.1-1.2-0.8-2c0.3-0.8,1.2-1.1,2-0.8c6.2,2.5,13,2.4,19-0.2 c0.8-0.3,1.6,0,2,0.8c0.3,0.8,0,1.6-0.8,2C43.4,56,39.7,56.7,35.9,56.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,37.7c-0.8,0-1.4-0.6-1.5-1.3c-0.8-6.7-4.1-12.6-9.3-16.6c-0.7-0.5-0.8-1.4-0.3-2.1 c0.5-0.7,1.4-0.8,2.1-0.3c5.8,4.5,9.6,11.3,10.4,18.6c0.1,0.8-0.5,1.6-1.3,1.7C60.1,37.7,60,37.7,60,37.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancesSeamlessCollaboration);
export default __webpack_public_path__ + "static/media/enhances-seamless-collaboration.677fe1789f2f780390e1c12ce9bfbdee.svg";
export { ForwardRef as ReactComponent };